// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9ffa9439","404":"c087f497","787":"ee052eac"}[chunkId] + ".chunk.js";
};